import React from 'react'
import { StaticQuery, Link } from 'gatsby'
import _ from 'lodash'
import Img from 'gatsby-image'
import styled from 'styled-components'

const BlogContent = styled.div`
  max-width: 750px;
  margin: 0 auto;

  a {
    text-transform: uppercase;
    display: block;
    text-align: center;
    margin: 1em 0;
  }

  @media screen and (max-width: 800px) {
    display: block;
  }
`

const Homepage = () => (
  <StaticQuery
    query={graphql`
      query BlogIndexQuery {
        allPrismicClient(filter: {data: {home_feature: {eq: true}}}) {
          edges {
            node {
              data {
                title {
                  text
                }
                homepage {
                    url
                    localFile {
                      publicURL
                      childImageSharp {
                        fluid {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                  }
                  # localFile(maxWidth: 910) {
                  #   ...childImageSharp
                  # }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <BlogContent>
        {data.allPrismicClient.edges.map(({ node }) => (
          <div>
            <Link to={`${_.kebabCase(node.data.title.text)}`}>
              {node.data.homepage && (
                <div>
                   <Img
              fluid={node.data.homepage.localFile.childImageSharp.fluid}
            />
                </div>
              )}
            </Link>
          </div>
        ))}
      </BlogContent>
    )}
  />
)

export default Homepage
